import { FC } from 'react';
import { Image, Row } from 'antd';
import { SwitchLanguage } from '../../SwitchLanguage';
import IMAGES from '../../../const/images';

const Header: FC = () => (
    <Row justify="space-between" align="middle">
        <Image
            preview={false}
            alt="fleets-logo"
            src={IMAGES.logo.horizontal}
            style={{ width: 124 }}
        />
        <SwitchLanguage />
    </Row>
);

export { Header };
